import * as v from "valibot";
import { fromPageParam } from "@/shared/model/detail-search-params";

export const searchParams = v.object({
  from: fromPageParam,
  viewId: v.optional(v.string()),
});
